const driverGuide = [
    {
        id : 'D001',
        name : 'Mr. Adam',
        position : 'Driver',
        contact : '0808829802',
        address : 'Jl. Jalan 1',
        status : 'Active',
        
    },
    {
        id : 'D002',
        name : 'Mr. Smith',
        position : 'Driver',
        contact : '0808829802',
        address : 'Jl. Jalan 1',
        status : 'Non Active',
        
    },
    {
        id : 'G001',
        name : 'Ms. eve',
        position : 'Guide',
        contact : '0808829802',
        address : 'Jl. Jalan 1',
        status : 'Active',
        
    },
    {
        id : 'G002',
        name : 'Ms. evelyn',
        position : 'Guide',
        contact : '0808829802',
        address : 'Jl. Jalan 1',
        status : 'Non Active',
        
    },
    {
        id : 'D001',
        name : 'Mr. Alex',
        position : 'Guide',
        contact : '0808829802',
        address : 'Jl. Jalan 1',
        status : 'Active',
        
    },
    
]

export default driverGuide